import { Reducer } from 'redux';
import { IManifestationsState, Types, ManifestationDataProps } from './types';

const INITIAL_STATE: IManifestationsState = {
  manifestations: [],
  selectedCustomerId: '',
  loading: false,
  error: false,
  fetched: false
};

type TCustomAction = {
  type: Types;
  payload: {
    manifestations: ManifestationDataProps[];

    customerId: string;
  };
};

const reducer: Reducer<IManifestationsState, TCustomAction> = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case Types.UPDATE_MANIFESTATIONS_SETTINGS:
      return {
        ...state,
        selectedCustomerId: action.payload.customerId
      };

    case Types.LOAD_MANIFESTATIONS:
      return {
        ...state,
        manifestations: [],
        selectedCustomerId: action.payload.customerId,
        loading: true,
        error: false
      };

    case Types.LOAD_MANIFESTATIONS_SUCCESS:
      return {
        ...state,
        manifestations: action.payload.manifestations,
        loading: false,
        fetched: true,
        error: false
      };

    case Types.LOAD_MANIFESTATIONS_FAILURE:
      return {
        ...state,
        manifestations: [],
        loading: false,
        fetched: true,
        error: true
      };

    case Types.CLEAR_MANIFESTATIONS_STATE:
      return INITIAL_STATE;

    default:
      return state;
  }
};

export default reducer;
